<template>
  <div class="home_content_wrapper">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "UserSubscriptionsHome",
};
</script>
